import { FC } from "react";
import { ExtractJobStatus, ExtractMetrics } from "../../services/dashboard/dashboard.types";
import {
  BoldExtractText, ExtractJobStatusCell, ExtractJobStatusList, ExtractJobStatusRow, ExtractMetricsContainer,
  ExtractText, SideDrawerLink, StyledTitle
} from "./MoaDashboard.styles";
import FailedAlert from "./FailedAlert";

interface ExtractMetricsDisplayProps {
  extractMetrics: ExtractMetrics
  title?: string
  emptyText: string
  openDrawer: (progressMetrics: ExtractJobStatus) => void;
  testName: string
}

const ExtractMetricsDisplay: FC<ExtractMetricsDisplayProps> = (
    {
      extractMetrics,
      title,
      emptyText,
      openDrawer,
      testName
    }
) => {

  const renderStatus = (
      progressMetrics: ExtractJobStatus
  ) => {
    return (
        <>
          {progressMetrics.failed !== 0 &&
            <>
              {progressMetrics.failed > progressMetrics.resolved
                  ? <FailedAlert
                      count={progressMetrics.failed - progressMetrics.resolved}
                      openDrawer={() => openDrawer(progressMetrics)}
                      id={progressMetrics.jobId}
                  />
                  : <SideDrawerLink
                      dataTestId={'resolvedText-' + progressMetrics.jobId}
                      label={progressMetrics.resolved + ' resolved'}
                      to={''}
                      onClick={() => openDrawer(progressMetrics)}
                  />
              }
            </>
          }
        </>
    )
  };

  return (
      <ExtractMetricsContainer>
        {!!title &&
          <StyledTitle>{title}</StyledTitle>
        }
        <ExtractJobStatusList data-testid={`${testName}Container`}>
          {!extractMetrics
              ? <StyledTitle>{emptyText}</StyledTitle>
              : extractMetrics.map((extractJobStatus) =>
                  (
                      <ExtractJobStatusRow
                          key={`${testName}-${extractJobStatus.jobId}`}
                          data-testid={`${testName}-${extractJobStatus.jobId}-row`}
                      >
                        <ExtractJobStatusCell>
                          <BoldExtractText data-testid={`${testName}-${extractJobStatus.jobId}-total`}>
                            {extractJobStatus.total}
                          </BoldExtractText>
                          {renderStatus(extractJobStatus)}
                        </ExtractJobStatusCell>
                        <ExtractText data-testid={`${testName}-${extractJobStatus.jobId}-type`}>
                          {extractJobStatus.extractType.toLowerCase()}
                        </ExtractText>
                        <ExtractText
                            data-testid={`${testName}-${extractJobStatus.jobId}-user`}
                            style={{
                              textAlign: 'right',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                        >
                          {extractJobStatus.userName}
                        </ExtractText>
                      </ExtractJobStatusRow>
                  )
              )
          }
        </ExtractJobStatusList>
      </ExtractMetricsContainer>
  );
};

export default ExtractMetricsDisplay;